import * as _ from 'lodash';

import { UserType, MixedUserChoice } from './MixedUserChoice';

export interface IRecipientList {
    keywords: any;
    users: string[];
    roles: string[];
    approvalLevels: number[];
    userGroups: string[];
    emailAddresses?: string;
}

export function isInRecipients(list: IRecipientList, mixed: MixedUserChoice): boolean {
    let result = false;
    if (mixed.type === UserType.User) {
        result = _.some(list.users, uid => uid === mixed.originalObject.userId);
    } else if (mixed.type === UserType.Role) {
        result = _.some(list.roles, r => r === mixed.originalObject.name);
    } else if (mixed.type === UserType.UserGroup) {
        result = _.some(list.userGroups, g => g === mixed.originalObject.id);
    } else if (mixed.type === UserType.Level) {
        result = _.some(list.approvalLevels, l => l === mixed.originalObject);
    } else if (mixed.type === UserType.Keyword) {
        result = _.some(list.keywords, l => l === mixed.originalObject);
    }
    return result;
}

export function toRecipients(choices: MixedUserChoice[]): IRecipientList {
    const result: IRecipientList = { users: [], roles: [], approvalLevels: [], userGroups: [], keywords: [] };
    if (choices) {
        choices.forEach((c) => {
            switch (c.type) {
                case UserType.User:
                    result.users.push(c.originalObject.userId);
                    break;
                case UserType.Role:
                    result.roles.push(c.originalObject.name);
                    break;
                case UserType.UserGroup:
                    result.userGroups.push(c.originalObject.id);
                    break;
                case UserType.Level:
                    result.approvalLevels.push(c.originalObject);
                    break;
                case UserType.Keyword:
                    result.keywords.push(c.originalObject);
                    break;
                default:
                    break;
            }
        });
    }
    return result;
}